import { CloudAndProductNameTitle } from '../../components/CloudAndProductNameTitle'
import {
  EditPrivateOfferWrapper,
  EditPrivateOfferWrapperV2,
} from '../../components/NewPrivateOfferWrapper'
import { useFlyOutProductsBasedOnSelectedCloud } from '../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import {
  LayoutWrapper,
  SelectedCloudIcon,
  useCurrentCloudProvider,
} from '@labrav/common'
import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { PlanType } from '@labrav/react-components'
import PartnerProductsWrapper from '../PartnerProductsWrapper'
import PrivateOffersWrapper from '../PrivateOffersWrapper'
import { ExternalAppRoute } from '../ExternalAppRoute/ExternalAppRoute'
import { HandshakeOutlined } from '@mui/icons-material'
import { Product } from '../../modules/productsListing/reducer'
export const CreateEditPrivateOfferHubspotWrapper = () => {
  const { productId } = useParams<{
    productId: string
  }>()
  const cloudMarketplace = useCurrentCloudProvider()
  const { products } = useFlyOutProductsBasedOnSelectedCloud()
  const selectedProduct = products.find(
    (productItem: Product) => productItem.productId === productId
  )
  const { search } = useLocation()
  const fromValue = new URLSearchParams(search).get('from') || ''
  return (cloudMarketplace === 'AWS' &&
    selectedProduct?.productType === PlanType.CONTAINER) ||
    selectedProduct?.productType === PlanType.SAAS_CONTRACT ||
    selectedProduct?.productType === PlanType.SAAS_SUBSCRIPTION ||
    selectedProduct?.productType === PlanType.AMI ||
    cloudMarketplace === 'AZURE' ? (
    <LayoutWrapper
      title={
        fromValue === 'clone' ? 'Clone private offer' : 'Create a private offer'
      }
      component={ExternalNewPrivateOfferV2}
      actions={SelectedCloudIcon}
      customNavButton={{
        ButtonName: 'Back to Private offers',
        link: -1,
        shouldShowCustomNavButton: true,
      }}
      isExternal
    />
  ) : (
    <ExternalAppRoute
      titleIcon={<HandshakeOutlined fontSize="medium" />}
      title="New private offer"
      actions={CloudAndProductNameTitle}
      component={ExternalNewPrivateOffer}
      backButton
    />
  )
}

export const ExternalNewPrivateOfferV2 = () => {
  return (
    <PartnerProductsWrapper>
      <PrivateOffersWrapper>
        {({ externalBaseURL, search, crmOpportunityId, crmObjectLink }) => (
          <EditPrivateOfferWrapperV2
            externalBaseURL={externalBaseURL}
            crmOpportunityId={crmOpportunityId}
            crmObjectLink={crmObjectLink}
            search={search}
          />
        )}
      </PrivateOffersWrapper>
    </PartnerProductsWrapper>
  )
}

export const ExternalNewPrivateOffer = () => {
  return (
    <PartnerProductsWrapper>
      <PrivateOffersWrapper>
        {({ externalBaseURL, search, crmOpportunityId, crmObjectLink }) => (
          <EditPrivateOfferWrapper
            externalBaseURL={externalBaseURL}
            crmOpportunityId={crmOpportunityId}
            crmObjectLink={crmObjectLink}
            search={search}
          />
        )}
      </PrivateOffersWrapper>
    </PartnerProductsWrapper>
  )
}
